
import { AssetTypeInfoBase } from './asset.typeinfo.base';


export class AssetTypeInfo extends AssetTypeInfoBase {
  auditRouteBase = ["/asset/audit"];
}

export const ASSET_TYPE: AssetTypeInfo = new AssetTypeInfo();



